import React from 'react';

/**
 * UploadOverlay
 * Drop inside a modal/form to block the UI during an upload.
 * @param {boolean} isVisible  - show/hide the overlay
 * @param {string}  message    - optional status text (default: "Uploading…")
 */
const UploadOverlay = ({ isVisible, message = 'Uploading, please wait…' }) => {
    if (!isVisible) return null;

    return (
        <div style={overlayStyle}>
            <div style={cardStyle}>
                {/* Spinning ring */}
                <div style={ringWrapStyle}>
                    <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        style={{ animation: 'gobooze-spin 0.9s linear infinite' }}
                    >
                        <circle
                            cx="32" cy="32" r="28"
                            stroke="#ffe0f0"
                            strokeWidth="6"
                        />
                        <path
                            d="M32 4 a28 28 0 0 1 28 28"
                            stroke="#d3178a"
                            strokeWidth="6"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>

                {/* Pulsing dots row */}
                <div style={{ display: 'flex', gap: '6px', marginBottom: '12px' }}>
                    {[0, 1, 2].map(i => (
                        <span
                            key={i}
                            style={{
                                width: 8, height: 8,
                                borderRadius: '50%',
                                background: '#d3178a',
                                display: 'inline-block',
                                animation: `gobooze-pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
                            }}
                        />
                    ))}
                </div>

                <p style={msgStyle}>{message}</p>
                <p style={subStyle}>Please don't close this window</p>
            </div>

            {/* Keyframe styles injected once */}
            <style>{`
                @keyframes gobooze-spin {
                    from { transform: rotate(0deg); }
                    to   { transform: rotate(360deg); }
                }
                @keyframes gobooze-pulse {
                    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
                    40%           { transform: scale(1);   opacity: 1;   }
                }
            `}</style>
        </div>
    );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: 9999,
    background: 'rgba(0, 0, 0, 0.55)',
    backdropFilter: 'blur(3px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const cardStyle = {
    background: '#fff',
    borderRadius: '16px',
    padding: '40px 48px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
    maxWidth: '320px',
    width: '90%',
};

const ringWrapStyle = {
    marginBottom: '16px',
};

const msgStyle = {
    fontSize: '15px',
    fontWeight: 600,
    color: '#1a1a2e',
    margin: 0,
    textAlign: 'center',
};

const subStyle = {
    fontSize: '12px',
    color: '#888',
    margin: '4px 0 0',
    textAlign: 'center',
};

export default UploadOverlay;
